import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ title, description, keywords, image, url }) => {
    const siteTitle = 'PrimeApuesta | Apuestas Deportivas, eSports, Space Crash y Casino';
    const siteDescription = '⚽ Apuesta en las mejores cuotas de Fútbol, eSports, NBA y Tenis. 🚀 Gana a lo grande en Space Crash y Mines Pro. 🎰 Casino en Vivo, Slots y Retiros Inmediatos. ¡Tu sitio de confianza en Bolivia!';
    const siteUrl = 'https://primeapuesta.com';
    const siteImage = 'https://primeapuesta.com/logo192.png';

    return (
        <Helmet>
            {/* Standard Metadata */}
            <title>{title ? `${title} | PrimeApuesta` : siteTitle}</title>
            <meta name="description" content={description || siteDescription} />
            <meta name="keywords" content={keywords || 'apuestas, casino, deportes, fútbol, esports, space crash, mines pro, nba, tenis, blackjack, ruleta, slots, bonos, apuestas en bolivia, dota 2, csgo, apuestas internacionales'} />
            <link rel="canonical" href={url || siteUrl} />
            <link rel="alternate" href={url || siteUrl} hrefLang="es" />
            <link rel="alternate" href={url || siteUrl} hrefLang="es-BO" />
            <link rel="alternate" href={url || siteUrl} hrefLang="x-default" />
            <meta name="robots" content="index, follow" />

            {/* Open Graph / Facebook */}
            <meta property="og:type" content="website" />
            <meta property="og:url" content={url || siteUrl} />
            <meta property="og:title" content={title ? `${title} | PrimeApuesta` : siteTitle} />
            <meta property="og:description" content={description || siteDescription} />
            <meta property="og:image" content={image || siteImage} />

            {/* Twitter */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:url" content={url || siteUrl} />
            <meta name="twitter:title" content={title ? `${title} | PrimeApuesta` : siteTitle} />
            <meta name="twitter:description" content={description || siteDescription} />
            <meta name="twitter:image" content={image || siteImage} />
        </Helmet>
    );
};

export default SEO;
